import { FC } from 'react';
import styles from './InputHelperBlock.style';

interface InputHelperBlockProps {
    errorText?: string;
    helperText?: string;
    dataTestId?: string;
}

export const InputHelperBlock: FC<InputHelperBlockProps> = ({
    errorText,
    helperText,
    dataTestId,
}) => {
    const classes = styles();

    return (
        <div
            className={classes.helperTextContainer}
            {...(dataTestId && { 'data-testid': dataTestId })}
        >
            <p className={`${classes.helperText} ${errorText && classes.errorText}`}>
                {errorText || helperText}
            </p>
        </div>
    );
};
